// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-tooltip-trigger {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 3;
  opacity: 0;
  transition: opacity var(--animation-duration-default);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 24px 24px 0;
  border-color: transparent var(--color-glass-card) transparent transparent;
  cursor: pointer;
}
.info-tooltip-trigger:hover {
  opacity: 1 !important;
}
td:hover .info-tooltip-trigger {
  opacity: 0.5;
}
.info-tooltip-trigger .info-icon {
  position: absolute;
  top: -1px;
  right: -18px;
  color: var(--color-text);
  font-size: 8px;
  font-weight: 700;
}

.droppable-area {
  display: flex;
  flex-direction: column;
  gap: calc(var(--gutter) / 4);
  min-height: 32px;
  height: 100%;
  padding: 0;
  border-radius: var(--radius-default);
  transition: background-color var(--animation-duration-default), border var(--animation-duration-default);
  border: 1px dashed transparent;
}
.droppable-area.droppable-hover {
  background-color: var(--color-dropzone);
  border: 1px dashed var(--color-dropzone-border);
}

.filtered-table.filtered-count-1 td {
  height: var(--team-member-height);
}
.filtered-table.filtered-count-2 td {
  height: calc(2 * var(--team-member-height) + var(--gutter));
}
.filtered-table.filtered-count-3 td {
  height: calc(3 * var(--team-member-height) + var(--gutter) * 1.25);
}
.filtered-table.filtered-count-4 td {
  height: calc(4 * var(--team-member-height) + var(--gutter) * 1.5);
}
.filtered-table.filtered-count-5 td {
  height: calc(5 * var(--team-member-height) + var(--gutter) * 1.75);
}
.filtered-table td {
  transition: height var(--animation-duration-default) ease;
  padding: calc(var(--gutter) / 4) !important;
  overflow-y: auto;
}
.filtered-table td .droppable-area {
  height: 100%;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/views/TableView.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,qDAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;EACA,yEAAA;EACA,eAAA;AACF;AACE;EACE,qBAAA;AACJ;AAGE;EACE,YAAA;AADJ;AAIE;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,wBAAA;EACA,cAAA;EACA,gBAAA;AAFJ;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,oCAAA;EACA,wGAAA;EACA,8BAAA;AAJF;AAME;EACE,uCAAA;EACA,+CAAA;AAJJ;;AAWE;EACE,iCAAA;AARJ;AAWE;EACE,2DAAA;AATJ;AAYE;EACE,kEAAA;AAVJ;AAaE;EACE,iEAAA;AAXJ;AAcE;EACE,kEAAA;AAZJ;AAgBE;EACE,yDAAA;EACA,2CAAA;EACA,gBAAA;AAdJ;AAiBI;EACE,YAAA;EACA,gBAAA;AAfN","sourcesContent":[".info-tooltip-trigger {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 3;\n  opacity: 0;\n  transition: opacity var(--animation-duration-default);\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 0 24px 24px 0;\n  border-color: transparent var(--color-glass-card) transparent transparent;\n  cursor: pointer;\n\n  &:hover {\n    opacity: 1 !important;\n  }\n\n  // Make the tooltip corner visible when hovering the cell\n  td:hover & {\n    opacity: 0.5;\n  }\n  \n  .info-icon {\n    position: absolute;\n    top: -1px;\n    right: -18px;\n    color: var(--color-text);\n    font-size: 8px;\n    font-weight: 700;\n  }\n} \n\n// Basic droppable area styling\n.droppable-area {\n  display: flex;\n  flex-direction: column;\n  gap: calc(var(--gutter) / 4);\n  min-height: 32px;\n  height: 100%;\n  padding: 0;\n  border-radius: var(--radius-default);\n  transition: background-color var(--animation-duration-default), border var(--animation-duration-default);\n  border: 1px dashed transparent;\n  \n  &.droppable-hover {\n    background-color: var(--color-dropzone);\n    border: 1px dashed var(--color-dropzone-border);\n  }\n}\n\n// Table styles for when chip filter is applied (chips other than \"all\")\n.filtered-table {\n  // Dynamic height calculation based on number of selected members\n  &.filtered-count-1 td {\n    height: var(--team-member-height);\n  }\n  \n  &.filtered-count-2 td {\n    height: calc(2 * var(--team-member-height) + var(--gutter));\n  }\n  \n  &.filtered-count-3 td {\n    height: calc(3 * var(--team-member-height) + var(--gutter) * 1.25);\n  }\n  \n  &.filtered-count-4 td {\n    height: calc(4 * var(--team-member-height) + var(--gutter) * 1.5);\n  }\n  \n  &.filtered-count-5 td {\n    height: calc(5 * var(--team-member-height) + var(--gutter) * 1.75);\n  }\n  \n  // Generic case for higher numbers (fallback)\n  td {\n    transition: height var(--animation-duration-default) ease;\n    padding: calc(var(--gutter) / 4) !important; // Remove vertical padding as it's handled by the droppable area\n    overflow-y: auto; // Allow scrolling for extra content\n    \n    // Make droppable areas fill the available height\n    .droppable-area {\n      height: 100%;\n      overflow-y: auto;\n    }\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
